import React from 'react';
import {
  Box,
  Container,
  Grid,
  Paper,
  Skeleton,
} from '@mui/material';

const UsageSkeleton: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="text" width="30%" height={40} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="50%" height={24} />
      </Box>

      {/* Cards de estatísticas */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[1, 2, 3].map((item) => (
          <Grid item xs={12} sm={4} key={item}>
            <Paper elevation={2} sx={{ p: 3 }}>
              <Skeleton variant="circular" width={56} height={56} sx={{ mb: 2 }} />
              <Skeleton variant="text" width="70%" height={32} />
              <Skeleton variant="text" width="50%" height={20} />
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Gráfico */}
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Skeleton variant="text" width="40%" height={32} sx={{ mb: 3 }} />
        <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 1 }} />
      </Paper>

      {/* Tabela de histórico */}
      <Paper elevation={2} sx={{ p: 3 }}>
        <Skeleton variant="text" width="35%" height={32} sx={{ mb: 2 }} />
        {[1, 2, 3, 4, 5].map((item) => (
          <Box key={item} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="40%" />
            </Box>
            <Skeleton variant="text" width="10%" />
          </Box>
        ))}
      </Paper>
    </Container>
  );
};

export default UsageSkeleton;





